import styles from './StatusBadge.module.css'

export type ProjectStatus =
  | 'uploaded'
  | 'action_needed'
  | 'in_review'
  | 'analysis_in_progress'
  | 'results_available'

export interface StatusBadgeProps {
  status: ProjectStatus
}

const LABELS: Record<ProjectStatus, string> = {
  uploaded: 'Hochgeladen',
  action_needed: 'Aktion erforderlich',
  in_review: 'In Prüfung',
  analysis_in_progress: 'Analyse läuft',
  results_available: 'Ergebnis verfügbar',
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const safeStatus: ProjectStatus = status && status in LABELS ? status : 'uploaded'
  return (
    <span className={[styles.badge, styles[safeStatus]].filter(Boolean).join(' ')}>
      {LABELS[safeStatus]}
    </span>
  )
}
